<template>
  <div class="flex justify-between">
    <div v-for="(c, i) in chars" :key="i" v-html="c"></div>
  </div>
</template>

<script>
export default {
  name: "JustifiedHeaderText",
  props: {
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    chars() {
      const charArray = [];
      const words = this.text.split(" ");
      for (let i = 0; i < words.length; i++) {
        charArray.push(...words[i]);
        if (i !== words.length - 1) {
          charArray.push("&nbsp");
        }
      }
      return charArray;
    }
  }
};
</script>

<style scoped></style>
